import type { MaskitoOptions } from '@maskito/core';

/**
 * Built-in {@link CadsInputConfig.mask} presets. Hosts pass these ids only—concrete Maskito options stay internal to
 * CADS so we can swap implementations without breaking the public contract.
 */
export type CadsInputMaskPreset = 'none' | 'us-phone';

const digit = /\d/;

/**
 * NANP display mask `(###) ###-####` (10 digit slots). The bound {@link ControlValueAccessor} value is this **display
 * string** (digits plus parentheses, space, and hyphen)—not digits-only. Optional on phone fields; use
 * {@link CadsInputMaskPreset} `none` when the control must accept more than 10 digits in one field (e.g. E.164-style
 * input with {@link createPhoneControl}'s default validator).
 */
export const CADS_INPUT_US_PHONE_MASKITO: MaskitoOptions = {
  mask: ['(', digit, digit, digit, ')', ' ', digit, digit, digit, '-', digit, digit, digit, digit],
};

/** Resolves a config `mask` preset to Maskito options, or `null` when masking is off. */
export function cadsInputMaskitoOptions(mask: CadsInputMaskPreset | undefined): MaskitoOptions | null {
  switch (mask ?? 'none') {
    case 'none':
      return null;
    case 'us-phone':
      return CADS_INPUT_US_PHONE_MASKITO;
    default:
      return null;
  }
}
